import { AbstractTransaction } from './types';

export const getIsLoading = ({ isLoading }: AbstractTransaction) => isLoading;

export const getIsLoaded = ({ isLoaded }: AbstractTransaction) => isLoaded;

export const getValidationFailed = ({
  validationFailed,
}: AbstractTransaction) => validationFailed;
export const getHasFailed = ({ hasFailed }: AbstractTransaction) => hasFailed;
export const hasError = ({ error }: AbstractTransaction) => error;
